import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Vector from "../assets/SVG/vector";
import done from "../assets/image/doneSignin.png";
import SidebarSignin from "../components/signin/sidebarSignin";
import SigninGroupForm from "../components/signin/signinGroupForm";
import SigninGroupForm1 from "../components/signin/signinGroupForm1";
import SigninEquipment from "../components/signin/signinEquipment";
import SigninBranch from "../components/signin/signinBranch";
import { Link } from "react-router-dom";
import logo from "../assets/image/logo.png";
import { getMyInformation } from "../api/signin";

export default function SigninGruop() {
  const [level, setLevel] = useState(1);
  const [update, setUpdate] = useState(false);
  const [dataAll, setDataAll] = useState();
  const [dataForm1, setDataForm1] = useState({
    name: "",
    fatherName: "",
    birthDay: "",
    universityYear: "",
    endManageYear: "",
    field: "",
    university: "",
    nid: "",
    cid: "",
    phone: "",
    sex: "MALE",
    password: "",
    passwordRepeat: "",
  });
  const [dataCheckCode, setDataCheckCode] = useState({
    token: "",
    phone: "",
    code: 0,
  });
  const [dataForm2, setDataForm2] = useState({
    groupName: "",
    establishYear: "",
    atlasCode: "",
    totalTrips: "",
    recentTrips: "",
    totalMembers: "",
    recentMembers: "",
    managersCount: "",
    membersPerTrip: "",
    tripDays: "",
    regionsCount: "",
    pageAddress: "",
    site: "",
    platform: "",
    lodgment: "",
    groupRegistrationPlace: "",
    tripFrequency: "",
    tripRadius: "",
    address: "",
    tel: "",
  });
  const [dataForm3, setDataForm3] = useState({
    densityUnitCount: "",
    pullToothCount: 0,
    restorationToothCount: 0,
    rooterCanalCount: 0,
    imagingEquipmentCount: 0,
    barometerCount: 0,
    glucometerCount: 0,
    paravanCount: 0,
    bedCount: 0,
    monitoringCount: 0,
    examinationSetCount: 0,
    ecgCount: 0,
    electronicShockCount: 0,
    revivingBagCount: 0,
    popEsmirCount: 0,
    sonoKidCount: 0,
    wifeExaminationEquipmentCount: 0,
    samplingEquipmentCount: 0,
    geneticallyBedCount: 0,
    optometryEquip1: 0,
    optometryEquip2: 0,
    optometryEquip3: 0,
    optometryEquip4: 0,
    optometryEquip5: 0,
    audiologistEquip1: 0,
    audiologistEquip2: 0,
    audiologistEquip3: 0,
    audiologistEquip4: 0,
    audiologistEquip5: 0,
    imagingEquip1: 0,
    imagingEquip2: 0,
    imagingEquip3: 0,
    laboratoryEquip1: 0,
    laboratoryEquip2: 0,
    laboratoryEquip3: 0,
    laboratoryEquip4: 0,
    laboratoryEquip5: 0,
    mediaEquip1: 0,
    mediaEquip2: 0,
    mediaEquip3: 0,
    customEquips: {
      additionalProp1: 0,
      additionalProp2: 0,
      additionalProp3: 0,
    },
  });
  const [dataForm4, setDataForm4] = useState({
    screeningSicknesses: [""],
    publicDoctors: "",
    donateMedicine: "",
    medicalSections: ["EDUCATIONAL"],
    medicalExpertises: [],
    adultEducation: false,
    childEducation: false,
    freeGlass: false,
    freeHearingAids: false,
    popEsmirTest: false,
    cancerTest: false,
    socialWorkAssistance: false,
    quitAddiction: false,
    familyPsychology: false,
    urineAnalysis: false,
    bloodCellsCountTest: false,
    bioChemTest: false,
    hormonTest: false,
    movementHelpEquipments: false,
  });
  // console.log(dataForm2);
  useEffect(() => {
    if (window.location.search.split("?", 2)[1]) {
      getMyInformation()
        .then((x) => {
          setDataAll(x);
          setUpdate(true);
        })
        .catch((z) => console.log(z));
    }
  }, []);
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="left"
      style={{
        background: "linear-gradient(180deg, #6cbbc7 0%, #6cbbc7 100%)",
      }}
      width="100vw"
      height="100vh"
      position="fixed"
    >
      {level !== 5 && (
        <>
          <Box height="100%" width="100%">
            <Box m="30px">
              <img style={{ width: "80px", height: "auto" }} src={logo} />
            </Box>
            <Box mt="80px" display="grid" justifyItems={"center"}>
              <SidebarSignin setLevel={setLevel} level={level} />
            </Box>
          </Box>
          <Box
            className="cardLogin"
            sx={{ overflow: "scroll" }}
            width="80%"
            bgcolor="white"
            ml="14px"
          >
            <Box display="flex" justifyContent="left">
              {level === 1 && (
                <Link
                  to={window.location.search.split("?", 2)[1] ? "/" : "/signin"}
                >
                  <Box
                    sx={{ cursor: "pointer" }}
                    width="fit-content"
                    m="30px 40px"
                  >
                    <Vector />
                  </Box>
                </Link>
              )}
            </Box>
            <Box mt={level !== 1 ? "40px" : ""} display={"grid"} p="0px 70px">
              {level === 1 && (
                <SigninGroupForm
                  dataCheckCode={dataCheckCode}
                  setDataCheckCode={setDataCheckCode}
                  dataForm={dataAll || dataForm1}
                  setDataForm={setDataAll || setDataForm1}
                  setLevel={setLevel}
                  update={update}
                />
              )}
              {level === 2 && (
                <SigninGroupForm1
                  setDataForm={setDataAll || setDataForm2}
                  dataForm={dataAll || dataForm2}
                  setLevel={setLevel}
                  update={update}
                />
              )}
              {level === 3 && (
                <SigninEquipment
                  dataForm={dataAll || dataForm3}
                  setDataForm={setDataAll || setDataForm3}
                  setLevel={setLevel}
                  level={level}
                  update={update}
                />
              )}
              {level === 4 && (
                <SigninBranch
                  dataForm={dataAll || dataForm4}
                  setDataForm={setDataAll || setDataForm4}
                  setLevel={setLevel}
                  level={level}
                  update={update}
                />
              )}
            </Box>
          </Box>
        </>
      )}
      {level === 5 && (
        <Box display="grid" justifyItems="center" width="100%">
          <img src={done} />
          <Box mt="50px" textAlign="center">
            <Typography color="white" fontSize="25px">
              ثبت نام با موفقیت انجام شد!
            </Typography>
            <Typography color="white" fontSize="25px">
              به زودی از سوی قرارگاه جهادی اثر با شما تماس گرفته خواهد شد.
            </Typography>
            <Link to="/login">
              <Typography
                color="white"
                bgcolor="green"
                p="5px 10px"
                borderRadius="10px"
                width="fit-content"
                margin="auto"
                mt="20px"
                sx={{ cursor: "pointer" }}
              >
                {"متوجه شدم"}
              </Typography>
            </Link>
          </Box>
        </Box>
      )}
    </Box>
  );
}
